<template>
  <el-container class="height100 marginL32">
    <el-container v-show="showmode == 'LIST'">
      <el-container
        class="el-mainContent height100"
        direction="vertical"
        ref="userLogMain"
      >
        <el-row
          class="obpm-fromContent-title obpm-enterpriseDomain-logo normalHeight"
          ref="normalHeader"
        >
          <el-col :span="24" class="normalLineH">
            <i class="fa fa-clock-o f24" aria-hidden="true"></i>
            <span class="marginL20">定时任务</span>
          </el-col>
        </el-row>
        <el-row ref="search" class="mt-5">
          <el-col :span="24">
            <el-form
              :inline="true"
              :model="params"
              class="form-inline"
              size="mini"
              @submit.native.prevent
            >
              <el-form-item>
                <el-input
                  v-model="params.searchword"
                  :placeholder="$t('name')"
                  @keyup.enter.native="searchTableData"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="searchTableData" type="primary" plain>{{
                  $t('query')
                }}</el-button>
                <el-button @click="resetSearchData">{{
                  $t('reset')
                }}</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <!-- 操作日志列表 -->
        <el-table
          :data="logdata.datas"
          class="overflowYscroll"
          ref="multipleTable"
          row-key="id"
          header-cell-class-name="tableHeaderbg"
          size="small"
          :height="tableListConHeight"
        >
          <!-- <el-table-column
              type="selection"
              width="55">
            </el-table-column> -->
          <el-table-column prop="name" :label="$t('name')"> </el-table-column>
          <el-table-column prop="creator" :label="$t('creator')">
          </el-table-column>
          <el-table-column prop="period" :label="$t('period')">
            <template slot-scope="scope">
              <span v-if="scope.row.period == 8192">{{
                $t('immediately')
              }}</span>
              <span v-else-if="scope.row.period == 34">{{ $t('minute') }}</span>
              <span v-else-if="scope.row.period == 546">{{ $t('hour') }}</span>
              <span v-else-if="scope.row.period == 2">{{ $t('day') }}</span>
              <span v-else-if="scope.row.period == 32">{{ $t('weeks') }}</span>
              <span v-else-if="scope.row.period == 512">{{
                $t('months')
              }}</span>
              <span v-else>{{ $t('do_not_repeat') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="rDate" :label="$t('runtime')">
          </el-table-column>
          <el-table-column prop="runtimes" :label="$t('runnum')">
          </el-table-column>
          <el-table-column prop="startupType" :label="$t('startup_type')">
            <template slot-scope="scope">
              <span v-if="scope.row.startupType == 0">{{ $t('manual') }}</span>
              <span v-else-if="scope.row.startupType == 1">{{
                $t('auto')
              }}</span>
              <span v-else>{{ $t('banned') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="state" :label="$t('state')">
            <template slot-scope="scope">
              <span v-if="scope.row.state == 0">{{ $t('stoped') }}</span>
              <span v-else> {{ $t('run') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="state" :label="$t('state')">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.state == 0"
                size="mini"
                type="primary"
                @click="startTask(scope.row)"
                >开始</el-button
              >
              <el-button
                v-else
                size="mini"
                type="danger"
                @click="stopTask(scope.row)"
                >停止</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="searchTableData"
          :current-page.sync="params.pageNo"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="params.linesPerPage"
          layout="prev, pager, next, total, sizes"
          background
          :total="logdata.rowCount ? logdata.rowCount : 0"
        ></el-pagination>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
export default {
  created() {
    this.getCustomApps()
  },
  mounted() {
    // var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.tableListConHeight =
      this.$refs.userLogMain.$el.getClientRects()[0].height -
      this.$refs.normalHeader.$el.getClientRects()[0].height -
      this.$refs.search.$el.getClientRects()[0].height
  },
  data() {
    return {
      showmode: 'LIST',
      logdata: {},
      params: {
        data: [],
        searchword: '',
        pageNo: 1,
        linesPerPage: 10,
      },
      multipleSelection: [],
      isLog: 'true',
      content: {},
      tableListConHeight: null,
    }
  },
  methods: {
    getCustomApps() {
      this.$api.getCustomAppConfig(
        { domainid: this.$route.query.domainid, data: { name: '' } },
        {
          onSucess: (resp) => {
            let arr = resp.data.data.datas
            arr.map((elm) => {
              this.params.data.push(elm.id)
            })
            this.searchTableData()
          },
        }
      )
    },
    startTask(row) {
      let data = {
        id: row.id,
        rTime: row.rTime,
        rDate: row.rDate,
      }
      this.$api.startTask(data, {
        onSucess: (resp) => {
          if (resp.data.errcode == 0) {
            this.$message({
              showClose: true,
              message: resp.data.data.msg,
              type: 'success',
            })
            this.searchTableData()
          } else {
            this.$message({
              showClose: true,
              message: resp.data.errmsg,
              type: 'error',
            })
          }
        },
      })
    },
    stopTask(row) {
      let data = {
        id: row.id,
      }
      this.$api.stopTask(data, {
        onSucess: (resp) => {
          if (resp.data.errcode == 0) {
            this.$message({
              showClose: true,
              message: resp.data.data.msg,
              type: 'success',
            })
            this.searchTableData()
          } else {
            this.$message({
              showClose: true,
              message: resp.data.errmsg,
              type: 'error',
            })
          }
        },
      })
    },
    handleSizeChange(size) {
      this.params.linesPerPage = size
      this.searchTableData()
    },
    searchTableData() {
      this.$api.getTaskList(this.params, this.params.data, {
        onSucess: (resp) => {
          this.logdata = resp.data.data
        },
      })
    },
    resetSearchData() {
      this.params = {
        data: [],
        searchword: '',
        pageNo: 1,
        linesPerPage: 10,
      }
      this.searchTableData()
    },
  },
}
</script>